import React, { useState } from 'react';
import { EnvelopeIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const NewsletterSignup = ({ compact = false }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success' | 'error' | null

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      setStatus('error');
      return;
    }

    setLoading(true);
    
    try {
      // API entegrasyonu yapılacak
      // const response = await fetch('/api/newsletter', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ email })
      // });
      
      // Simülasyon
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      setStatus('success');
      setEmail('');
      
      setTimeout(() => setStatus(null), 5000);
    } catch (error) {
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  // Compact version for footer
  if (compact) {
    return (
      <div className="py-6">
        <h3 className="font-bold text-text-dark mb-3 text-sm">E-Bülten</h3>
        <p className="text-xs text-gray-600 mb-3">Yeni ürünler ve kampanyalardan haberdar olun</p>
        <form onSubmit={handleSubmit} className="space-y-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-posta adresiniz"
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-green"
            disabled={loading}
          />
          <button
            type="submit"
            disabled={loading || !email}
            className="w-full px-4 py-2 bg-brand-green text-white text-sm font-semibold rounded-lg hover:bg-brand-green-dark disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Gönderiliyor...' : 'Abone Ol'}
          </button>
          {status === 'success' && (
            <p className="text-xs text-green-600 flex items-center gap-1">
              <CheckCircleIcon className="w-4 h-4" />
              Başarıyla abone oldunuz!
            </p>
          )}
          {status === 'error' && (
            <p className="text-xs text-red-600">
              Geçerli bir e-posta adresi girin.
            </p>
          )}
        </form>
      </div>
    );
  }

  // Full version (not used on homepage anymore)
  return (
    <div className="w-full bg-gradient-to-r from-brand-green to-brand-purple py-16 my-12">
      <div className="max-w-4xl mx-auto px-4 text-center">
        {/* İkon */}
        <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-6">
          <EnvelopeIcon className="w-8 h-8 text-brand-green" />
        </div>

        {/* Başlık */}
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-3">
          📧 E-Bülten Aboneliği
        </h2>
        <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
          E-bültenimize abone olun, yeni ürünler ve özel kampanyalardan ilk siz haberdar olun.
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit} className="max-w-md mx-auto">
          <div className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-posta adresiniz"
              className="flex-1 px-6 py-4 rounded-full text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-4 focus:ring-white/30"
              disabled={loading}
            />
            <button
              type="submit"
              disabled={loading || !email}
              className="px-8 py-4 bg-white text-brand-green font-bold rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed transition-all transform hover:scale-105"
            >
              {loading ? 'Gönderiliyor...' : 'Abone Ol'}
            </button>
          </div>

          {/* Status Messages */}
          {status === 'success' && (
            <div className="mt-4 flex items-center justify-center gap-2 text-white bg-white/20 rounded-full px-6 py-3">
              <CheckCircleIcon className="w-5 h-5" />
              <span>✅ Başarıyla abone oldunuz!</span>
            </div>
          )}
          
          {status === 'error' && (
            <div className="mt-4 text-red-100 bg-red-500/20 rounded-full px-6 py-3">
              ❌ Bir hata oluştu. Lütfen geçerli bir e-posta adresi girin.
            </div>
          )}
        </form>

        {/* Güven Mesajı */}
        <p className="text-white/70 text-sm mt-6">
          🔒 E-posta adresiniz güvendedir. İstediğiniz zaman abonelikten çıkabilirsiniz.
        </p>
      </div>
    </div>
  );
};

export default NewsletterSignup;
